export default {
  departements: [],
}
